import { Component, inject, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TextToSpeechService } from '@web/core/services/text-to-speech.service';

@Component({
  selector: 'casa-doc-text-to-speech-button',
  templateUrl: './text-to-speech-button.component.html',
  styleUrl: './text-to-speech-button.component.scss',
  standalone: false,
})
export class TextToSpeechButtonComponent {
  @Input() message = '';
  translateService = inject(TranslateService);
  textToSpeechService = inject(TextToSpeechService);

  onSpeech() {
    this.textToSpeechService.speech({
      message: this.message,
    });
  }
}
